<template>
<div id="interface" v-on:dblclick.native="cycleStyles()">

  <div class="top-left-wrapper">

    <!-- PRODUCT SELECT -->

    <div class="interactable product">
      <div class="type-small">SELECT PRODUCT</div>
      <div class="styles-wrapper" @mouseenter="showStyles = true" @mouseleave="showStyles = false" v-touch:tap="showStylesTouch">
        <p>
          <vue-typer :style="isMobile ? 'border-bottom: 1px solid #00ff00' : ''" :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='0' :type-delay='35' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink'
            :text='currentStyle.style'></vue-typer>
          <img :style="showStyles ? 'opacity: 0; transform: translateY(5px)  ' : 'opacity: 1;  transform: translateY(0px) '" class="triangle-icon" src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDMwNiAzMDYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwNiAzMDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iZXhwYW5kLW1vcmUiPgoJCTxwb2x5Z29uIHBvaW50cz0iMjcwLjMsNTguNjUgMTUzLDE3NS45NSAzNS43LDU4LjY1IDAsOTQuMzUgMTUzLDI0Ny4zNSAzMDYsOTQuMzUgICAiIGZpbGw9IiMwMGZmMDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
          />
        </p>
        <ol v-show="showStyles">
          <li v-for="(n, index) in filteredStyles.length" :key="index" @click="changeCurrentStyle(filteredStyles[index].value,filteredStyles[index] )">
            <vue-typer v-if="showStyles" :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='150 * index' :type-delay='35' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink' :text='filteredStyles[index].style'></vue-typer>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- MUTE BUTTON  -->

  <div class="mute-button interactable">
    <!-- <div class="mute-button interactable" @click="muteSounds2()"> -->
    <div v-if="state.muteStatus">

      <svg id="unmuted" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.5 33.5">
  <path class="cls-1" d="M495,379a1.1,1.1,0,0,1,1-1.08l4.51-.35a2.88,2.88,0,0,0,1.66-.82l7.17-8A2.56,2.56,0,0,1,511,368h1a1,1,0,0,1,1,1v30a1,1,0,0,1-1,1h-1a2.56,2.56,0,0,1-1.67-.75l-7.17-8a3.25,3.25,0,0,0-1.66-.9l-4.52-.7a1.21,1.21,0,0,1-1-1.15Z" transform="translate(-494.25 -367.25)"/>
  <g>
    <path class="cls-1" d="M524.59,394.63a15,15,0,0,0-.2-21.45" transform="translate(-494.25 -367.25)"/>
    <path class="cls-1" d="M521.94,392a11.25,11.25,0,0,0-.22-16.14M521.5,384" transform="translate(-494.25 -367.25)"/>
    <path class="cls-1" d="M519.35,389.26a7.5,7.5,0,0,0-.29-10.8" transform="translate(-494.25 -367.25)"/>
  </g>
</svg>
    </div>
    <div v-else>

      <svg id="muted" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.5 33.5">
  <path class="cls-1" d="M523.5,368.5a1.1,1.1,0,0,1,1-1.08l4.51-.35a2.88,2.88,0,0,0,1.66-.82l7.17-8a2.56,2.56,0,0,1,1.67-.75h1a1,1,0,0,1,1,1v30a1,1,0,0,1-1,1h-1a2.56,2.56,0,0,1-1.67-.75l-7.17-8a3.25,3.25,0,0,0-1.66-.9l-4.52-.7a1.21,1.21,0,0,1-1-1.15Z" transform="translate(-522.75 -356.75)"/>
  <line class="cls-1" x1="24.75" y1="12.75" x2="32.75" y2="20.75"/>
  <line class="cls-1" x1="32.75" y1="12.75" x2="24.75" y2="20.75"/>
</svg>
    </div>
  </div>

  <!-- CLAIM AND BUTTONS -->
  <div class="bottom-wrapper el-p">
    <p class="claim">The Air Max 720 goes bigger than ever with Nike's tallest Air bag yet.</p>
    <div class="button-wrapper">
      <div class="columns  is-centered is-mobile">
        <div class="column is-narrow _button interactable" @mouseover="isHovering = true" @mouseout="isHovering = false">
          <p :class="isHovering? 'glitch-1': ''" style="color: black" data-text="Shop Now">Shop Now</p>
        </div>
      </div>
    </div>
  </div>

  <!-- POPUP -->

  <div v-if="!isMobile" class="popup-wrapper">

    <transition name="slide-fade" duration="1000" mode="out-in">
      <vue-drag-resize v-if="showPopup" :key="currentPopUp.index" :parentLimitation="true" :isResizable="false" :y="popupY" :x="popupX" :w="popupWidth">
        <div class="corner corner-1">
        </div>
        <div class="corner corner-2">
          <p class="interactable popup-close" @click="showPopup = false">X</p>
        </div>
        <div class="animation-wrapper">
          <div class="interactable popup">
            <vue-typer id="typewriter" @typed-char='onTypedChar' :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='50' :type-delay='15' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink'
              :text='this.currentPopUp.content'></vue-typer>
          </div>
        </div>
        <div class="corner corner-3">
        </div>
        <div class="corner corner-4">
        </div>
      </vue-drag-resize>
    </transition>
  </div>

  <!-- POPUP MOBILE -->
  <!-- <div v-if="isMobile" class="popup-wrapper-mobile" v-touch:tap="showPopup = false" @click="showPopup = false"> -->
  <div v-if="isMobile" class="popup-wrapper-mobile interactable">
    <transition name="slide-fade" duration="1000" mode="out-in">
      <div v-if="showPopup" :key="currentPopUp.index">
        <div class="">
          <p class="interactable popup-close" style="transform: rotate(0)" @click="showPopup = false">X</p>
        </div>
        <div class="animation-wrapper" @click="showPopup = false">
          <div class="interactable popup-mobile">
            <vue-typer id="typewriter" @typed-char='onTypedChar' :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='50' :type-delay='15' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink'
              :text='this.currentPopUp.content'></vue-typer>
          </div>
        </div>
      </div>
    </transition>
  </div>


  <!-- UI ELEMENTS -->

  <div class="ui-wrapper el-p">

    <!-- SLIDER  -->

    <div :class="isMobile ? 'slider-wrapper-mobile': 'slider-wrapper'">
      <div class="slider-helper">

        <div class="slider-information interactable columns is-marginless is-desktop">
          <div v-if="!isMobile" class="column is-narrow exp-left is-paddingless" @click="cycleExperiments('left')"><img style=" transform: rotate(90deg)" class="triangle-icon-exp" src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDMwNiAzMDYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwNiAzMDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iZXhwYW5kLW1vcmUiPgoJCTxwb2x5Z29uIHBvaW50cz0iMjcwLjMsNTguNjUgMTUzLDE3NS45NSAzNS43LDU4LjY1IDAsOTQuMzUgMTUzLDI0Ny4zNSAzMDYsOTQuMzUgICAiIGZpbGw9IiMwMGZmMDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
            /></div>

          <div :class="isMobile ? 'column': 'column exp-select'">
            EXPERIMENT<br>

            <!-- <vue-typer :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='0' :type-delay='75' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink' :text='currentExperiment.experiment'></vue-typer> -->
            <div class="styles-wrapper-exp" @mouseenter="showExperiments = true" @mouseleave="showExperiments = false" v-touch:tap="showExperimentsTouch">
              <div v-if="!isMobile">
                <vue-typer :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='0' :type-delay='25' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink' :text='currentExperiment.experiment'></vue-typer>

              </div>
              <div @click="cycleExperiments()" v-if="isMobile">
                <vue-typer style="border-bottom: 1px solid #00ff00" :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='0' :type-delay='25' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink'
                  :text='currentExperiment.experiment'></vue-typer>

              </div>
              <div v-if="!isMobile">
                <ol v-show="showExperiments">
                  <li v-for="(n, index) in filteredExperiments.length" :key="index" @click="changeCurrentExperiment(filteredExperiments[index])">
                    <vue-typer v-if="showExperiments" :repeat="0" :shuffle='false' initial-action='typing' :pre-type-delay='150 * index' :type-delay='25' :pre-erase-delay='0' :erase-delay='0' erase-style='clear' :erase-on-complete='false' caret-animation='blink' :text='filteredExperiments[index].experiment'></vue-typer>
                  </li>
                </ol>
              </div>
            </div>

          </div>

          <div @click="cycleExperiments()" v-if="isMobile" class="round-button column is-narrow is-paddingless">
            <p>CYCLE<br>EXP.</p>
          </div>
          <div v-if="!isMobile" class="column is-narrow exp-right is-paddingless" @click="cycleExperiments()"><img style=" transform: rotate(-90deg)" class="triangle-icon-exp" src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDMwNiAzMDYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwNiAzMDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0iZXhwYW5kLW1vcmUiPgoJCTxwb2x5Z29uIHBvaW50cz0iMjcwLjMsNTguNjUgMTUzLDE3NS45NSAzNS43LDU4LjY1IDAsOTQuMzUgMTUzLDI0Ny4zNSAzMDYsOTQuMzUgICAiIGZpbGw9IiMwMGZmMDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
            /></div>

        </div>
        <div class="slider-helper-2 " :class="slider.value == 0 ? 'warning-test' : ''">

          <input class="input-range interactable" type="range" step="0.001" v-model="slider.value" min="0" max="100">
        </div>
        <div class="slider-information" :class="slider.value == 0 ? 'warning' : ''">
          INTENSITY:<br>{{displayIntensity}}%
        </div>
      </div>
    </div>

    <!--
    <div :class="!isMobile ? 'ui-cctv':'ui-cctv-mobile'">

    </div> -->

    <!-- NIKE FLAIR -->
    <div v-if="!isMobile" class="ui-element ui-nike-flair">
      <img style="position: absolute" class="rotateZ" :src="img.uiNikeFlairB">
      <img style="position: absolute" :src="img.uiNikeFlairA">
    </div>

    <!-- HUD -->
    <div :class="isMobile ? 'ui-element ui-1-mobile' : 'ui-element ui-1'">
      <img :src="img.ui1">
    </div>
    <div class="ui-element ui-0">
      <img :src="img.ui0">
    </div>
    <div v-if="!isMobile" class="ui-element ui-2">
      <img :src="img.ui0">
    </div>
  </div>
</div>
</template>

<script>
import anime from 'animejs';
import {
  VueTyper
} from 'vue-typer'
import VueDragResize from 'vue-drag-resize';


export default {
  name: 'interface',
  components: {
    VueTyper,
    VueDragResize
  },
  props: ['isMobile'],
  data() {
    return {
      slider: {
        value: 0
      },
      styles: [{
        style: 'AIRMAX_720_SUNSET',
        value: 0
      }, {
        style: 'AIRMAX_720_TOTAL_ECLIPSE',
        value: 1
      }, {
        style: 'AIRMAX_720_SEA_FOREST',
        value: 2
      }, {
        style: 'AIRMAX_720_PINK_SEA',
        value: 3
      }],
      experiments: [{
        experiment: 'CUSHIONING',
        // objective: 'Objective Copy (inflate)'
      }, {
        experiment: 'FLEX',
        // objective: 'Objective Copy (twist)'
      }, {
        experiment: 'COMFORT',
        // objective: 'Objective Copy (deform)'
      }],
      popups: [{
          index: 0,
          content: '#NOTE: 6mm taller than 270. Too much?! #NOTE_ENDS'
        },
        {
          index: 1,
          content: '#NOTE: Recyc_Manufact_Waste at 75%. Performance still 100%. #NOTE_ENDS'
        },
        {
          index: 2,
          content: '#NOTE: All-round Air unit = most bouncebackable. #NOTE_ENDS'
        },
        {
          index: 3,
          content: '#NOTE: Oooh. Pretty bubbles. Noice. #NOTE_ENDS'
        },
        {
          index: 4,
          content: '#NOTE: Organic_Energy_Radiate simulation complete. Upper design finalised. #NOTE_ENDS'
        },
        {
          index: 5,
          content: '#NOTE: All-round Air unit = most bouncebackable. >Continue tests. #NOTE_ENDS'
        }
      ],
      translatedPopups: [{
          'lang': "en",
          "content": [
            "#NOTE: All-round Air unit = most bouncebackable. >Continue tests. #NOTE_ENDS",
            "#NOTE: Organic_Energy_Radiate simulation complete. Upper design finalised. #NOTE_ENDS",
            "#NOTE: All-round Air unit = most bouncebackable. #NOTE_ENDS",
            "#NOTE: 6mm taller than 270. Too much?! #NOTE_ENDS",
            "#NOTE: Recyc_Manufact_Waste at 75%. Performance still 100%. #NOTE_ENDS",
            "#NOTE: Oooh. Pretty bubbles. Noice. #NOTE_ENDS"
          ]
        },
        {
          'lang': "en-GB",
          "content": ["#NOTE: All-round Air unit = most bouncebackable. >Continue tests. #NOTE_ENDS", "#NOTE: Organic_Energy_Radiate simulation complete. Upper design finalised. #NOTE_ENDS",
            "#NOTE: All-round Air unit = most bouncebackable. #NOTE_ENDS", "#NOTE: 6mm taller than 270. Too much?! #NOTE_ENDS", "#NOTE: Recyc_Manufact_Waste at 75%. Performance still 100%. #NOTE_ENDS",
            "#NOTE: Oooh. Pretty bubbles. Noice. #NOTE_ENDS"
          ],

        },
        {
          'lang': "cs",
          "content": ["#NOTE: Komplexní jednotka Air = nejlepší odrazivost. >Testy pokračují. #NOTE_ENDS", "#NOTE: Simulace vyzařuje_organickou_energii dokončena. Design svršku finalizován. #NOTE_ENDS",
            "#NOTE: Komplexní jednotka Air = nejlepší odrazivost. #NOTE_ENDS", "#NOTE: O 6 mm vyšší než model 270. Je to příliš?! #NOTE_ENDS", "#NOTE: Recyklace_a_odpady_při_výrobě 75 %. Výkon zůstává stoprocentní. #NOTE_ENDS",
            "#NOTE: To jsou ale krásné bubliny. Nádhera. #NOTE_ENDS"
          ],
        },
        {
          'lang': "da",
          "content": ["#NOTE: All-round Air enhed = bedste bounceback evne. >Forsæt tests. #NOTE_ENDS", "#NOTE: Simulation af Organisk_Energi_Udstråling fuldført. Design af overdel fuldført. #NOTE_ENDS",
            "#NOTE: All-round Air enhed = bedste bouncebak evne. #NOTE_ENDS", "#NOTE: 6mm højere end 270. For meget?! #NOTE_ENDS", "#NOTE: Genbrug_Fremstil_Spild 75%. Performance stadig 100%. #NOTE_ENDS",
            "#NOTE: Oooh. Flotte bobler. Støj. #NOTE_ENDS"
          ],
        },
        {
          'lang': "de",
          "content": ["#NOTE: Air-Rundumelement = bestes Bounceback. >Weiter testen. #NOTE_ENDS", "#NOTE: Organic_Energy_Radiate-Simulation abgeschlossen. Obermaterial-Design fertig. #NOTE_ENDS",
            "#NOTE: Air-Rundumelement = bestes Bounceback. #NOTE_ENDS",
            "#NOTE: 6 mm höher als der 270. Zu viel?! #NOTE_ENDS", "#NOTE: Recyc_Manufact_Waste 75 %. Performance weiterhin 100 %. #NOTE_ENDS", "#NOTE: Woah. Super Air. Super stylish. #NOTE_ENDS"
          ]
        },
        {
          'lang': "el",
          "content": ["#NOTE: Μονάδα Air σε όλη τη σόλα = τρελή επαναφορά. >Συνεχίζουμε τις δοκιμές. #NOTE_ENDS", "#NOTE: Ολοκληρώθηκε η προσομοίωση Έκλυση_Οργανικής_Ενέργειας. Έκλεισε η σχεδίαση του επάνω μέρους. #NOTE_ENDS",
            "#NOTE: Μονάδα Air σε όλη τη σόλα = τρελή επαναφορά. #NOTE_ENDS", "#NOTE: 6 mm πιο ψηλό από το 270. Έχουμε ξεφύγει;! #NOTE_ENDS", "#NOTE: Ανακύκλωση_Κατασκευαστικών_Αποβλήτων στο 75%. Οι επιδόσεις σταθερά στο 100%. #NOTE_ENDS",
            "#NOTE: Πόσο τέλειες οι φυσαλίδες. Δώσαμε πόνο πάλι. #NOTE_ENDS"
          ],

        },
        {
          'lang': "es-ES",
          "content": ["#NOTE: Unidad Air completa = más elasticidad. >Continuar pruebas. #NOTE_ENDS", "#NOTE: Simulación de radiación de energía orgánica completada. Diseño de la parte superior finalizado. #NOTE_ENDS",
            "#NOTE: Unidad Air completa = más elasticidad. #NOTE_ENDS", "#NOTE: 6 mm más altas que las 270. ¡¿Demasiado?! #NOTE_ENDS", "#NOTE: 75 % materiales reciclados 75 %. 100 % rendimiento. #NOTE_ENDS",
            "#NOTE: ¡Vaya! Bonitas burbujas. Quedan genial. #NOTE_ENDS"
          ],

        },
        {
          'lang': "es-419",
          "content": ["#NOTE: Unidad Air completa = más elasticidad. > Seguir con las pruebas. #NOTE_ENDS", "#NOTE: Organic_Energy_Radiate Simulación completa. Diseño de la parte superior finalizado. #NOTE_ENDS",
            "#NOTE: Unidad Air completa = más elasticidad. #NOTE_ENDS", "#NOTE: 6 mm más alto que el 270. ¿Es demasiado? #NOTE_ENDS", "#NOTE: Con un 75% de materiales reciclados. Rendimiento al 100%. #NOTE_ENDS",
            "#NOTE: Bonitas burbujas. Genial. #NOTE_ENDS"
          ],

        },

        {
          'lang': "fr",
          "content": ["#NOTE: Bulle d'Air à 720 degrés = un rebond inédit. >Continuer les tests. #NOTE_ENDS", "#NOTE: Energie_Naturelle_Libérée simulation terminée. Design de l'empeigne finalisé. #NOTE_ENDS",
            "#NOTE: Bulle d'Air à 720 degrés = un rebond inédit. #NOTE_ENDS", "#NOTE: 6mm plus haute que la 270. C'est trop ?! #NOTE_ENDS", "#NOTE: Recyc_Fabrication_Gaspillage à 75%. Performance toujours à 100%. #NOTE_ENDS",
            "#NOTE: Oooh. La jolie bulle. Dément. #NOTE_ENDS"
          ],

        },
        {
          'lang': "hu",
          "content": ["#NOTE: Teljes méretű Air egység = a legruganyosabb. >Tesztek folytatása. #NOTE_ENDS", "#NOTE: Az organikus_energia_sugárzása szimuláció befejeződött. Felsőrész véglegesítve. #NOTE_ENDS",
            "#NOTE: Teljes méretű Air egység = a legruganyosabb. #NOTE_ENDS", "#NOTE: 6 mm-rel magasabb, mint a 270. Túl sok?! #NOTE_ENDS", "#NOTE: Gyártási_selejt_újrahasznosítása 75%. A teljesítmény még mindig 100%. #NOTE_ENDS",
            "#NOTE: Óóó. Csodás buborékok. Szuper. #NOTE_ENDS"
          ],

        },
        {
          'lang': "it",
          "content": ["#NOTE: Unità Air a 360° = massima reattività. >Continuare test. #NOTE_ENDS", "#NOTE: Simulazione diffusione energia completa. Design superiore finalizzato. #NOTE_ENDS",
            "#NOTE: Unità Air a 360° = massima reattività. #NOTE_ENDS", "#NOTE: 6mm più alta della 270. Troppo?! #NOTE_ENDS", "#NOTE: Materiali riciclati al 75%. Performance sempre al 100%. #NOTE_ENDS", "#NOTE: Oooh. Belle bolle! #NOTE_ENDS"
          ],

        },
        {
          'lang': "nb",
          "content": ["#NOTE: All-round Air unit = mest bouncebackable. >Fortsett testing. #NOTE_ENDS", "#NOTE: Organic_Energy_Radiate simulering fullført. Design av overdel avsluttet. #NOTE_ENDS",
            "#NOTE: All-round Air unit = mest bouncebackable. #NOTE_ENDS", "#NOTE: 6mm høyere enn 270. For mye?! #NOTE_ENDS", "#NOTE: Recyc_Manufact_Waste på 75%. Ytelse fortsatt 100%. #NOTE_ENDS", "#NOTE: Åhh. Flotte bobler. Bråk. #NOTE_ENDS"
          ],

        },
        {
          'lang': "nl",
          "content": ["#NOTE: Allround Air unit = meest veerkrachtige ooit. >Ga door met testen. #NOTE_ENDS", "#NOTE: Simulatie Organic_Energy_Radiate voltooid. Design bovenwerk afgerond. #NOTE_ENDS",
            "#NOTE: Allround Air unit = meest veerkrachtige ooit. #NOTE_ENDS", "#NOTE: 6 mm hoger dan 270. Te hoog?! #NOTE_ENDS", "#NOTE: Recyc_Manufact_Waste op 75%. Performance nog steeds 100%. #NOTE_ENDS",
            "#NOTE: Aah, mooie bellen. Nice. #NOTE_ENDS"
          ],

        },
        {
          'lang': "pl",
          "content": ["#NOTE: Pełnowymiarowa poduszka gazowa Air = największa sprężystość. >Kontynuuj testy. #NOTE_ENDS", "#NOTE: Symulacja generowania energii organicznej ukończona. Projekt cholewki gotowy. #NOTE_ENDS",
            "#NOTE: Pełnowymiarowa poduszka gazowa Air = największa sprężystość. #NOTE_ENDS", "#NOTE: O 6mm wyższa niż w modelu 270. To zbyt wiele?! #NOTE_ENDS",
            "#NOTE: 75% materiałów z recyklingu. Funkcjonalność wciąż na poziomie 100%. #NOTE_ENDS", "#NOTE: Och! Urocze bąbelki. Jak miło. #NOTE_ENDS"
          ],

        },
        {
          'lang': "pt-PT",
          "content": ["#NOTE: Unidade Air a todo o comprimento = ressalto máximo. >Continuar testes. #NOTE_ENDS", "#NOTE: Simulação de radiação de energia orgânica concluída. Design da parte superior terminado. #NOTE_ENDS",
            "#NOTE: Unidade Air a todo o comprimento = ressalto máximo. #NOTE_ENDS", "#NOTE: 6 mm mais altas do que as 270. Demasiado?! #NOTE_ENDS", "#NOTE: 75% de material reciclado. Desempenho permanece 100%. #NOTE_ENDS",
            "#NOTE: Oooh. Bolhas bonitas. Fixe. #NOTE_ENDS"
          ],

        },
        {
          'lang': "ru",
          "content": ["#NOTE: Вставка Air по всей подошве = максимальная упругость. >Продолжить тестирование. #NOTE_ENDS", "#NOTE: Симуляция рассеяния органической энергии завершена. Дизайн верха готов. #NOTE_ENDS",
            "#NOTE: Вставка Air по всей подошве = максимальная упругость. #NOTE_ENDS", "#NOTE: На 6 мм выше, чем у 270. Это слишком?! #NOTE_ENDS", "#NOTE: Переработанных материалов — 75%. Функциональность — 100%. Как всегда. #NOTE_ENDS",
            "#NOTE: Ооо. Пузырики. Круто. #NOTE_ENDS"
          ],

        },
        {
          'lang': "sv",
          "content": ["#NOTE: All-round Air-enhet = högsta studsfaktor. >Fortsätt tester. #NOTE_ENDS", "#NOTE: Simulering av organisk_energiöverföring avslutad. Design av ovandel slutförd. #NOTE_ENDS",
            "#NOTE: All-round Air-enhet = högsta studsfaktor. #NOTE_ENDS", "#NOTE: 6 mm högre än 270. För mycket?! #NOTE_ENDS", "#NOTE: Återvinn_avfall 75 %. Funktionalitet fortf. 100 %. #NOTE_ENDS",
            "#NOTE: Åhhh. Schyssta bubblor. Grymt. #NOTE_ENDS"
          ],

        },
        {
          'lang': "tr",
          "content": ["#NOTE: Çepeçevre Air birimi = en iyi geri tepme kabiliyeti. >Testlere devam et. #NOTE_ENDS", "#NOTE: Organic_Energy_Radiate simülasyonu tamamlandı. Üst tasarıma son şekli verildi. #NOTE_ENDS",
            "#NOTE: Çepeçevre Air birimi = en iyi geri tepme kabiliyeti. #NOTE_ENDS", "#NOTE: 270'ten 6 mm daha uzun. Çok fazla?! #NOTE_ENDS", "#NOTE: Recyc_Manufact_Waste %75. Performans hala %100. #NOTE_ENDS",
            "#NOTE: Oooh. Güzel Air bölmeleri. Harika. #NOTE_ENDS"
          ]

        }
      ],
      // styles: ['AIRMAX_720_MENS 1', 'AIRMAX_720_MENS 2', 'AIRMAX_720_WOMEN 1', 'AIRMAX_720_WOMAN 2'],
      currentExperiment: '',
      currentStyle: '',
      currentPopUp: {
        index: 5,
        title: 'Title 6',
        content: 'dsfgs drgesgerers r sit amet, consertz rz tet ermpor '
      },
      showStyles: false,
      showExperiments: false,
      showPopup: false,
      isHovering: false,
      img: {
        ui0: require('@/assets/ui_b_0.png'),
        ui1: require('@/assets/ui_b_1.png'),
        uiNikeFlairA: require('@/assets/ui_nike_flair_a.png'),
        uiNikeFlairB: require('@/assets/ui_nike_flair_b.png'),
      },
      alpha: 0,
      beta: 0,
      gamma: 0,
      state: {
        width: window.innerWidth,
        height: window.innerHeight,
        muted: true,
        audioContext: '',
        muteStatus: false
      },
      canGo: true,
      canGoExp: true,
      countWord: 0,
    }
  },
  computed: {
    displayIntensity() {
      return Number(this.slider.value).toFixed(2)
    },
    filteredStyles() {
      return _.filter(this.styles, (e) => e.style != this.currentStyle.style)
    },
    filteredExperiments() {
      return _.filter(this.experiments, (e) => e.experiment != this.currentExperiment.experiment)
    },
    popupWidth() {
      return this.state.width / 5
    },
    popupX() {
      return this.state.width - (this.state.width / 100 * 6) - this.popupWidth
    },
    popupY() {
      return this.state.height * 0.6
      // return this.state.height / 40 * .8
    },
    getFirstBrowserLanguage() {
      var nav = window.navigator,
        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
        i,
        language;
      if (Array.isArray(nav.languages)) {
        for (i = 0; i < nav.languages.length; i++) {
          language = nav.languages[i];
          if (language && language.length) {
            return language;
          }
        }
      }
      for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
        language = nav[browserLanguagePropertyKeys[i]];
        if (language && language.length) {
          return language;
        }
      }

      return null;
    }
  },
  methods: {
    getTranslation() {
      var translation = _.filter(this.translatedPopups, (e) => {
        if (e.lang.toLowerCase() == this.getFirstBrowserLanguage.toLowerCase()) {
          return e
        } else if (e.lang.toLowerCase() == this.getFirstBrowserLanguage.substring(0, 2).toLowerCase()) {
          return e
        } else if (e.lang.substring(0, 2).toLowerCase() == this.getFirstBrowserLanguage.substring(0, 2).toLowerCase()) {
          return e
        } else {
          return
        }
      })
      if (translation.length == 0) {
        translation = []
        translation.push(this.translatedPopups[0])
      }
      var latinAmerica = ['es-ar', 'es-bo', 'es-cl', 'es-co', 'es-mx', 'es-cr', 'es-do', 'es-ec', 'es-sv', 'es-gt', 'es-hn', 'es-ni', 'es-pa', 'es-es', 'es-py', 'es-pe', 'es-pr', 'es-uy', 'es-ve'];
      if (this.getFirstBrowserLanguage.toLowerCase() == 'es-419' || _.some(latinAmerica, (el) => _.includes(this.getFirstBrowserLanguage.toLowerCase(), el))) {
        translation = _.filter(this.translatedPopups, (e) => {
          return e.lang == 'es-419'
        })
      }

      // for (var i = 0; i < this.popups.length; i++) {
      // this.popups[i].content = translation[0].content[i]
      this.popups[0].content = translation[0].content[3]
      this.popups[1].content = translation[0].content[4]
      this.popups[2].content = translation[0].content[2]
      this.popups[3].content = translation[0].content[5]
      this.popups[4].content = translation[0].content[1]
      this.popups[5].content = translation[0].content[0]
      // }
    },
    cycleStyles() {
      var self = this;
      // this.canGo = true;
      var delay = 1000;
      if (this.canGo) {
        this.canGo = false;
        var next = this.currentStyle.value + 1
        if (next >= this.styles.length) {
          next = 0
        }
        var style = _.find(this.styles, {
          value: next
        })
        this.changeCurrentStyle(next, style)
        setTimeout(function() {
          self.canGo = true;
        }, delay)
      } else {
        return
      }
    },
    cycleExperiments(direction) {

      if (!this.canGoExp) return
      var currentIndex = _.indexOf(this.experiments, this.currentExperiment);
      var next = currentIndex + 1;
      var prev = currentIndex - 1;
      if (next > this.experiments.length - 1) {
        next = 0
      }
      if (prev < 0) {
        prev = this.experiments.length - 1
      }

      if (direction == 'left') {
        this.changeCurrentExperiment(this.experiments[prev])
      } else {

        this.changeCurrentExperiment(this.experiments[next])
      }
    },

    muteSounds2() {
      this.state.muteStatus = !this.state.muteStatus
      // this.$root.$emit('muteSounds2')
      CABLES.patch.config.UI_audioContext()

    },

    changeCurrentStyle(index, style) {
      this.showStyles = false
      this.currentStyle = style
      this.$root.$emit('changeStyle', index)
    },
    changeCurrentExperiment(exp) {
      if (!this.canGoExp) return
      if (exp == this.currentExperiment) {
        return
      }
      this.showExperiments = false

      if (this.slider.value <= 1) {
        this.slider.value = 0
        this.currentExperiment = exp
        return
      }
      anime({
        targets: this.slider,
        value: 0,
        easing: 'easeInQuad',
        begin: () => {
          this.slider.lastValue = this.slider.value
          this.canGoExp = false
        },
        complete: () => {
          this.currentExperiment = exp;
          anime({
            targets: this.slider,
            value: this.slider.lastValue,
            easing: 'easeInQuad',
            complete: () => {
              this.canGoExp = true
            }
          })
        }
      })

    },
    changePopup(index) {
      // console.log(index);
      this.showPopup = true
      this.currentPopUp = this.popups[index]
    },
    showStylesTouch() {
      this.showStyles = true
    },
    showExperimentsTouch() {
      this.showExperiments = true
    },
    handleResize() {
      this.state.width = window.innerWidth
      this.state.height = window.innerHeight
    },
    onTypedChar: function(typedChar, typedCharIndex) {
      if (typedCharIndex == 0) {
        this.countWord = 0;
        document.getElementById('typewriter').firstChild.innerHTML = '';
      }
      var lessNodes = document.getElementById('typewriter').lastChild.childNodes;
      if (typedChar == " " || lessNodes.length == 1) {

        var finalNodes = document.getElementById('typewriter').firstChild;
        var listNodes = finalNodes.childNodes;

        var newNode = document.createElement('span');

        var x = this.countWord;
        var countNodes = listNodes.length;
        while (x < countNodes) {
          if (listNodes[this.countWord].innerHTML != " ")
            newNode.insertAdjacentElement('beforeend', listNodes[this.countWord]);
          else
            this.countWord++;

          // TODO: ADD LAST CHAR
          x++;
        }
        newNode.className = 'nowrap';
        finalNodes.insertAdjacentElement('beforeend', newNode);

        this.countWord++;
      }
    },
  },
  created() {
    this.getTranslation();
    this.currentStyle = this.styles[2]
    this.currentExperiment = this.experiments[0]
    if (!this.isMobile) window.addEventListener("resize", _.debounce(this.handleResize, 100), true);

  },
  destroyed() {
    if (!this.isMobile) window.removeEventListener("deviceorientation", this.handleResize, true);
  },
  mounted() {
    // this.changeCurrentStyle(2, this.styles[2].style)
    // this.$root.$emit('changeStyle', 1)
    // this.$nextTick(() => {
    // setTimeout(() => {
    // this.$root.$emit('changeStyle', 1)
    // console.log("style 1");
    // }, 500)

    // setTimeout(() => {
    //   this.$root.$emit('changeStyle', 2)
    //   console.log("style 2");
    // }, 1000)

    // })
    // this.$root.$emit('muteSounds2')

    var isChrome;
    var isChromium = window.chrome,
      winNav = window.navigator,
      vendorName = winNav.vendor,
      isOpera = winNav.userAgent.indexOf("OPR") > -1,
      isIEedge = winNav.userAgent.indexOf("Edge") > -1,
      isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome || (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
      // is Google Chrome
      isChrome = true
    }
    // this.state.audioContext = CABLES.patch.getOpsByName("WebAudioContextRunner")[0].getPortByName('Current State').value;
    var self = this;
    // self.muteSounds2()
    document.querySelector('.mute-button').addEventListener('click', () => {

      self.muteSounds2()
      // alert("clicked")
    });
    if (!this.isMobile) {

      if (isChrome) {
        // this._mute.setValue(true)
        // this.$root.$emit('muteSounds', true)
        // this.state.muteStatus = false
        // this.$root.$emit('muteSoundsDisplay', false)
        document.addEventListener('click', musicPlay);
      } else {
        // alert(isChrome)
        this.muteSounds2()
        // alert(isChrome)
        // this._mute.setValue(false)
        // this.state.muteStatus = !this.state.muteStatus
        // this.$root.$emit('muteSounds2')
        // this.$root.$emit('muteSoundsDisplay', true)

      }
    }

    function musicPlay() {
      // CABLES.patch.config.UI_audioContext()
      // alert("yada")
      self.$root.$emit('muteSounds2')
      self.state.muteStatus = !self.state.muteStatus

      // self.$root.$emit('muteSoundsDisplay', true)

      document.removeEventListener('click', musicPlay);
    }

    // if (this.state.audioContext == "suspended") {
    //   this.state.muteStatus = true
    // } else {
    //   this.state.muteStatus = false
    //
    // }

    // this.$root.$on('muteSoundsDisplay', (bool) => {
    //   this.state.muteStatus = bool
    // })
    this.$root.$on('openPopup', (index) => {
      this.changePopup(index)
    })
    this.$root.$on('cycleStyles', () => {
      this.cycleStyles()
    })
  },
  watch: {
    'slider.value': function() {
      this.$root.$emit('experimentStrength', Number(this.slider.value), this.currentExperiment.experiment)
    },
    // 'state.audioContext': function() {
    //   this.state.audioContext = CABLES.patch.getOpsByName("WebAudioContextRunner")[0].getPortByName('Current State').value;
    // }
  }

}
</script>

<style lang="scss">
$paddingY: 10vh;
$paddingX: 6vw;
$cornerSize: 4vh;

.slide-fade-enter-active {
    transition: all 0.5s ease;
    .popup-close {
        opacity: 1;
    }
    .animation-wrapper {
        animation: revealText 0.3s linear;
        animation-fill-mode: forwards;
    }
}
.slide-fade-leave-active {
    transition: all 0.5s ease;
    .popup-close {
        opacity: 0;
    }
    .animation-wrapper {
        animation: revealText linear reverse 0.3s;
        animation-fill-mode: forwards;
    }
}
.animation-wrapper {
    // width: 25vw;
    clip-path: inset(0px 0% 0px 0%);
    will-change: clip-path;
    // transition: all 0.5s ease;
}
@keyframes revealText {
    0% {
        clip-path: inset(0px 50% 0px 50%);
        max-height: 0;

        // -webkit-clip-path: inset(0px 50% 0px 50%);
        // opacity: 1;
    }
    100% {
        // opacity: 0;
        // clip-path: inset(0px 0px 0px 0px);
        max-height: 100%;

        clip-path: inset(0px 0% 0px 0%);
    }
}
@keyframes popupCornerToTop {
    0% {
        // bottom: calc(0%);
        // -webkit-clip-path: inset(0px 50% 0px 50%);
        opacity: 1;
    }
    100% {
        opacity: 0;
        // clip-path: inset(0px 0px 0px 0px);

        // bottom: calc(20% - 2vh + 2px);
        // transform: translateY(calc(-50% + 2vh - 2px)) rotate(180deg);
    }
}
@keyframes popupCornerToBottom {
    0% {
        // top: -$cornerSize;
        // -webkit-clip-path: inset(0px 50% 0px 50%);
        opacity: 1;
    }
    100% {
        opacity: 0;
        // clip-path: inset(0px 0px 0px 0px);
        // top: calc(20% - 6vh + 2px);
    }
}
/* .slide-fade-leave-active for <2.1.8 */
.slide-fade-enter {

    // opacity: 0;
    // overflow: hidden;
    // width: 0;
    .corner-2,
    .corner-2-mobile,
    .corner-3,
    .corner-3-mobile {
        left: calc(50% - 1px);
        // left: calc(50% + 2vh - 1px);
    }
    .corner-1,
    .corner-4 {
        left: calc(50% - 4vh);
        // left: calc(50% - 2vh + 1px);
    }

    .corner-3,
    .corner-3-mobile,
    .corner-4 {
        animation: popupCornerToTop reverse linear 0.5s;
        // animation-fill-mode: forwards;
        animation-delay: 0s;
    }
}

.slide-fade-leave-to {
    // transform: translateY(10px);
    // opacity: 0;
    // width: 0 !important;
    // background: red;
    .corner-2,
    .corner-2-mobile,
    .corner-3,
    .corner-3-mobile {
        left: calc(50% + 2vh - 1px);
    }
    .corner-1,
    .corner-4 {
        left: calc(50% - 2vh + 1px);
    }
    .corner-3,
    .corner-3-mobile,
    .corner-4 {
        // transition: bottom linear 0.4s, left linear 0.5s;
        animation: popupCornerToTop linear 0.4s;
        animation-fill-mode: forwards;
        animation-delay: 0.6s;
    }
    .corner-1,
    .corner-2,
    .corner-2-mobile {
        // transition: top linear 0.4s, left linear 0.5s;
        animation: popupCornerToBottom linear 0.4s;
        animation-fill-mode: forwards;
        animation-delay: 0.6s;
    }

}

@-webkit-keyframes rotationZ {
    from {
        -webkit-transform: rotateY(0deg);
    }
    to {
        -webkit-transform: rotateY(359deg);
    }
}

.rotateZ {
    animation: rotationZ 12s linear infinite;
}

.vue-typer .custom.caret {
    width: 10px;
    background-color: #00ff00;
    padding-left: 10px;
    // display: inline-block;
}
.vue-typer .custom.caret {
    animation-duration: 0.25s;
}

.interactable {
    pointer-events: auto !important;
}
.popup-close {
    // float: right;
    // right: -1em;
    // position: absolute;
    // top: -1em;
    // padding: 1em;
    // cursor: pointer;
    right: 0;
    position: absolute;
    transform: rotate(90deg);
    top: -0.7em;
    padding: 1em;
    cursor: pointer;
    transition: opacity 0.5s ease;
}

.corner {
    content: "";
    position: absolute;

    border-right: 1.5px solid #00ff00;
    border-bottom: 1.5px solid #00ff00;
    height: $cornerSize;
    // clip-path: inset(10px 10px 0px 10px);
    -webkit-mask-image: radial-gradient(circle 10px at $cornerSize $cornerSize, transparent 0, transparent 10px, black 11px);
    width: $cornerSize;
    transition: all 0.5s ease;
}

.corner-1 {
    top: -$cornerSize;
    left: -$cornerSize;
}
.corner-2 {
    top: -$cornerSize;
    left: 20vw;
    transform: rotate(90deg);
}
.corner-2-mobile {
    top: -$cornerSize;
    left: 60vw;
    transform: rotate(90deg);
}
.corner-3 {
    bottom: auto;
    left: 20vw;
    transform: rotate(180deg);

}
.corner-3-mobile {
    bottom: auto;
    left: 60vw;
    transform: rotate(180deg);

}
.corner-4 {
    // bottom: -$cornerSize;
    left: -$cornerSize;
    transform: rotate(270deg);

}

.popup-top {
    // border: 1px solid #00ff00;
    // border-bottom: 0;
    // border-top-left-radius: 1em;
    // border-top-right-radius: 1em;
    // padding: 0.25em 1em 0;
    // font-family: 'Monument Grotesk';
    display: inline-block;
    // padding: 0 1em 1em;
    padding-bottom: 1em;

    cursor: grab;
}
span.nowrap {
    white-space: nowrap;
}
.popup {
    width: 20vw;
    height: auto;
    // font-family: 'Monument Grotesk';

    // padding: 1em;
    // background: black;
    z-index: 40;
    // @include scanlines(rgb(20, 30, 20), 2px, 0deg, 0.5);
    // background: rgba(0,0,0,.5);
    overflow: hidden;
    // border: 1px solid #00ff00;
    &::before {
        // display: none !important;
    }
}
.popup-mobile {
    width: auto;
    height: auto;
    // padding: 1em;
    // background: black;
    z-index: 40;
    // @include scanlines(rgb(20, 30, 20), 2px, 0deg, 0.5);
    // background: rgba(0,0,0,.5);
    overflow: hidden;
    // border: 1px solid #00ff00;
    &::before {
        // display: none !important;
    }
}
.popup-wrapper {
    // background: rgba(0,255,0,.5);
    width: 100%;
    height: 100%;
    position: relative;
    ::before {
        display: none !important;
    }
}
.popup-wrapper-mobile {
    width: 60vw;
    // width: 20vw;
    // height: 200px;
    bottom: 25vh;
    margin-left: 2em;
    position: absolute;
}
.ui-element {
    position: absolute;
    // margin: 15vh 6vw;

    max-width: 225px;
    width: 25vh;
}
.bottom-wrapper {
    // width: 30vw;
    position: absolute;
    bottom: 4em;
    left: 50%;
    transform: translate(-50%, 0);
}
.cls-1 {
    fill: none;
    stroke: lime;
    stroke-miterlimit: 10;
    stroke-width: 1.5px;
}
.mute-button {
    position: absolute;
    top: 0;
    right: 0;
    height: 30px;
    width: 30px;
    margin: 6vh 6vw 0 0;
    cursor: pointer;
}
._button {
    margin: 0 0.25em;
    background: white;
    border-radius: 2em;
    min-width: 3em;
    text-align: center;
    color: black;
    font-family: 'Monument Grotesk', sans-serif;
    font-weight: bold;
    transition: transform 0.5s ease;
    cursor: pointer;
    p {
        padding: 0 2em;

    }
    &:hover {
        transform: translateY(-5px);
    }
}
.claim {
    padding-bottom: 2em;
    font-family: 'Monument Grotesk', sans-serif;
    color: white;
    text-align: center;
}
.top-left-wrapper {
    margin: 6vh 0 0 6vw;
    font-family: 'Monument Grotesk', sans-serif;
    font-size: 2em;
    .type-small {
        font-size: 0.5em;
        padding-right: 1em;
    }
}
.objective {
    font-size: 0.75em;
    opacity: 1;
    transition: opacity 1s ease;
}
.exp-select {
    min-height: 100px;
}
.styles-wrapper,
.styles-wrapper-exp {
    z-index: 20;
    .vue-typer:hover .left {
        // border-bottom: 1px solid #00ff00;
        background: #00ff00;
        span {

            color: black !important;
        }
    }
    .vue-typer span {

        cursor: pointer;
    }
}
.objective,
.product {
    margin-bottom: 0.25em;
    & > div {
        display: inline-block;

    }
}
.styles-wrapper {
    position: absolute;
    ol {
        list-style-type: none;
    }
}
.styles-wrapper-exp ol {
    list-style-type: none;

}

.ui-gui {
    margin: 1em !important;
    width: auto;
    top: 30%;
    position: absolute;
}
.ui-wrapper {
    position: absolute;
    height: 90%;
    bottom: 0;
    width: 100%;
}
.ui-0 {
    top: 0;
    left: 0;
    margin: $paddingY 0 0 $paddingX;

}

.ui-1 {
    bottom: 0;
    left: 0;
    margin: 0 0 $paddingY $paddingX;

}
.ui-1-mobile {
    top: 0;
    right: 0;
    transform: rotate(180deg);

    margin: $paddingY $paddingX 0 0;
}
.ui-2 {
    right: 0;
    top: 0;
    transform: rotate(90deg);
    // margin: 10vh 6vw 0vh 0;
    margin: $paddingY $paddingX 0 0;

}

.ui-nike-flair {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /* max-width: 150px;
  max-height: 150px; */
    width: 12vh;
    height: 12vh;
    margin-left: 0.5em;
}
.triangle-icon {
    display: inline;
    padding-left: 0.5em;
    max-width: 1.1em;
    transition: opacity 1s ease, transform 1s ease;
    img {
        // transform: scale(.85);
    }
}
// .exp-left,
// .exp-right {
//     transition: transform 0.5s ease;
// }
.exp-left .triangle-icon-exp:hover {
    transform: rotate(90deg) translateY(5px) !important;
}
.exp-right .triangle-icon-exp:hover {
    transform: rotate(-90deg) translateY(5px) !important;
}

@keyframes tapScale {
    0% {
        // top: -$cornerSize;
        // -webkit-clip-path: inset(0px 50% 0px 50%);
        transform: scale(1);
    }
    30% {
        transform: scale(.8);

    }
    100% {
        transform: scale(1);
        // clip-path: inset(0px 0px 0px 0px);
        // top: calc(20% - 6vh + 2px);
    }
}

.round-button {
    display: block;
    height: 6em;
    width: 6em;
    border-radius: 50%;
    border: 1px solid lime;
    margin: 1.5em auto 0;
    p {
        display: block;
        width: 100%;
        padding-top: 50%;
        padding-bottom: 50%;
        line-height: 1.2em;
        margin-top: -1.2em;

        text-align: center;

    }
    // &:active,
    // &:hover {
    //     animation: tapScale 0.5s ease both;
    // }
}
.triangle-icon-exp {
    // top: 6px;
    max-width: 3.5em;
    padding: 1em;
    cursor: pointer;
    // position: absolute;
    display: inline;
    // padding-left: 0.5em;
    transition: transform 0.5s ease;

    // transition: opacity 1s ease, transform 1s ease;
}
// Slider
.slider-information {
    text-transform: capitalize;
    margin: 1.5em 0;
}

.slider-wrapper {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
    width: 200px;
    /* -webkit-box-align: center; */
    text-align: center;
    font-size: 0.75em;
    -ms-flex-align: center;
    /* align-items: center; */
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    left: 15vw;
}
.slider-wrapper-mobile {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    // height: 70%;
    height: auto;
    // bottom: 0;
    top: 20%;
    right: calc(-40vw / 4);
    width: 40vw;
    /* -webkit-box-align: center; */
    text-align: center;
    font-size: 0.9em;
    -ms-flex-align: center;
    /* align-items: center; */
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    justify-content: space-evenly;
    /* left: 10vw; */
}
.slider-helper {
    // display: grid;
}
.slider-helper-2 {
    display: flex;
    height: 30vh;
}
.input-range {
    // margin: auto;
    // position: absolute;
    // top: 0;
    // left: 0;
    // bottom: 0;
    margin: auto;
    // right: 0;
    -webkit-appearance: none;
    width: 30vh;
    // border-radius: 5px;
    background: transparent;
    outline: none;
    transform: rotate(270deg);
    // writing-mode: bt-lr ;
    /* IE */
    // -webkit-appearance: slider-vertical ;
    /* WebKit */

}

// Firefox Overrides
::-moz-range-track {
    background: transparent;
    border: 0;
}

#interface {
    width: 100%;
    height: 100%;
    // background: rgba(255, 0, 0, 0.2);
    pointer-events: none;
    user-select: none;
    z-index: 3;
    position: fixed;
    bottom: 0;
}

input[type=range] {
    -webkit-appearance: none;
    padding-bottom: 3em;
    padding-top: 3em;
    cursor: pointer;
    // width: 100%;
}

input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
}

input[type=range]:focus {
    outline: none;
}

input[type=range]::-ms-track {
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
}
/*#############Thumb##############*/

input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 32px;
    width: 30px;
    // margin: 1em;
    background: linear-gradient(to left, transparent, transparent 75%, #00ff00 25%, #00ff00);
    background-size: 8px 100%;

    // background: #00ff00;
    overflow: hidden;
    cursor: pointer;
    margin-top: -15px;
}

input[type=range]::-moz-range-thumb {
    height: 32px;
    width: 30px;
    background: linear-gradient(to left, transparent, transparent 75%, #00ff00 25%, #00ff00);
    background-size: 8px 100%;
    overflow: hidden;
    cursor: pointer;
    background: #00ff00;
    cursor: pointer;
}

input[type=range]::-ms-thumb {
    height: 32px;
    width: 30px;
    background: linear-gradient(to left, transparent, transparent 75%, #00ff00 25%, #00ff00);
    background-size: 8px 100%;
    overflow: hidden;
    background: #00ff00;
    cursor: pointer;
}
/*#############Track##############*/

input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: #00ff00;
}

input[type=range]:active::-webkit-slider-runnable-track {
    background: #00ff00;
}

input[type=range]::-moz-range-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: #00ff00;
}

input[type=range]::-ms-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
}

input[type=range]::-ms-fill-lower {
    background: #00ff00;
}

input[type=range]:focus::-ms-fill-lower {
    background: #00ff00;
}

input[type=range]::-ms-fill-upper {
    background: #00ff00;
}

input[type=range]:focus::-ms-fill-upper {
    background: #00ff00;
}

@media only screen and (max-width: 768px) {

    .popup-close {
        top: -2em;
        transform: rotate(0deg);
        right: -2em;
    }
    .slider-information {
        font-size: 1em;
        margin-top: 0;
    }
    .ui-element {
        width: 20vw;
    }
    .ui-0,
    .ui-1-mobile {
        margin-top: 3vh;
    }
    .mute-button {
        position: absolute;
        bottom: 3em;
        height: auto;
        top: auto;
        padding: 0.5em;
        right: auto;
        display: block;
        left: 0;
        margin: 0 0 0 2em;
    }
    .top-left-wrapper {
        // margin: 10vh 0 0 0.5em;
        font-family: 'Monument Grotesk', sans-serif;
        font-size: 1.5em;
        .type-small {
            font-size: 0.7em;
            padding-right: 1em;
        }
    }
}

@media screen and (max-device-width: 812px) and (orientation:landscape) {
    html {
        font-size: 0.7em !important;
    }
    .ui-element {
        display: none;

    }
    .slider-wrapper-mobile {
        top: auto;
    }
    .round-button {
        margin-bottom: 2em;
    }
}

@media only screen and (max-width: 320px) {
    .type-small {
        font-size: 0.6em !important;
        padding-right: 0.25em !important;
    }
}
</style>
